import * as React from 'react';
export const giropaySvg = React.forwardRef(function giropaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 3.426C0 2.086 1.074 1 2.397 1h17.206C20.927 1 22 2.087 22 3.426l-.003 9.148c0 1.34-1.073 2.426-2.397 2.426H2.394c-1.323 0-2.397-1.087-2.397-2.426zM2.397 14H11l.003-11.983H2.4c-.837 0-1.397.677-1.397 1.513L1 12.502C1 13.338 1.56 14 2.397 14zm10.928-1.838h1.968V9h.023c.372.693 1.117.95 1.805.95 1.696 0 2.604-1.43 2.604-3.152 0-1.407-.864-2.94-2.44-2.94-.897 0-1.728.37-2.123 1.186h-.022v-1.05h-1.815zm3.172-3.755c-.656 0-1.204-.638-1.204-1.487 0-.871.481-1.52 1.204-1.52.767 0 1.193.671 1.193 1.442 0 .928-.448 1.565-1.193 1.565zM9.165 3.97v5.059c0 2.354-1.153 3.113-3.482 3.113a6.76 6.76 0 0 1-2.208-.363l.1-1.562c.61.297 1.12.472 1.953.472 1.152 0 1.774-.538 1.774-1.66V8.72h-.023c-.477.67-1.142.979-1.942.979-1.585 0-2.572-1.187-2.572-2.881 0-1.705.81-2.981 2.606-2.981.854 0 1.542.462 1.964 1.166h.022V3.97zM4.828 6.785c0 .89.533 1.396 1.131 1.396.71 0 1.276-.593 1.276-1.474 0-.638-.377-1.352-1.276-1.352-.743 0-1.131.65-1.131 1.43z',
    }),
  );
});
giropaySvg.defaultProps = {
  height: '16',
  viewBox: '0 0 22 16',
  width: '22',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var giropay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'giropay',
  svg: giropaySvg,
};
